import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import WITHDRAWN_IMAGE from "../../../images/Banner/withdrawn.jpg";
import NoImage from "../../images/resources/noImage.jpg";
const Current = ({ LiveData, Datastatus }) => {
  const [artist, setArtist] = useState("");
  const [title, setTitle] = useState("");
  const [LotNumber, setLotNumber] = useState("");
  const [image, setImage] = useState([]);
  const [auctionName, setAuctionName] = useState("");
  const [sold, setSold] = useState("");
  const phoneMatch = useMediaQuery("(max-width:600px)");
  const [withdrawn, setWithdrawn] = useState(0);

  useEffect(() => {
    try {
      setAuctionName(LiveData.auction_details.auction_name);
      setWithdrawn(LiveData.lot.details[0].isWithdrawn)
      setImage(LiveData.lot.image_lot);
      setLotNumber(
        <b
          style={{
            backgroundColor: "#6c757d",
            color: "white",
            padding: " 5px 10px",
            borderRadius: 5,
          }}
        >
          {LiveData.lot.details[0].lot_number}
        </b>
      );
      setTitle(LiveData.lot.details[0].title);
      setArtist(LiveData.lot.details[0].artist);
      // statunsFunction(LiveData.lot.details[0].lot_status);
      if (LiveData.lot.details[0].lot_status === "SOLD") {
        setSold(
          <div className="overlayDeclaratorCurrent" style={{ color: "#59bb59" }}>
            SOLD
          </div>
        );
      } else if (LiveData.lot.details[0].lot_status === "UNSOLD") {
        setSold(
          <div
            className="overlayDeclaratorCurrent"
            style={{ color: "#ff4949" }}
          >
            Unsold
          </div>
        );
      } else if (LiveData.lot.details[0].lot_status === "RESERVE_NOT_MET") {
        setSold(
          <div
            className="overlayDeclaratorCurrent"
            style={{ color: "#ff4949", paddingTop: "30%" }}
          >
            RESERVE NOT MET
          </div>
        );
      } else if (LiveData.lot.details[0].lot_status === "PASS") {
        setSold(
          <div
            className="overlayDeclaratorCurrent"
            style={{ color: "#0bf8bf" }}
          >
            PASS
          </div>
        );
      } else {
        setSold("");
      }
    } catch (error) {
      setImage("");
      setLotNumber("");
      setTitle("");
      setArtist("");
    }
  }, [LiveData, Datastatus]);

  return (
    <div>
      <Grid
        container
        style={{
          backgroundColor: "rgb(248 248 248)",
          borderRadius: "2px",
          //   boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)", LotNumber
        }}
      >
        <Grid item sm={6}>
          <div style={{ float: "left", height: "20%", padding: "8px" }}>
            <Typography variant="h5">{auctionName}</Typography>
            <br />

            <Typography variant="h6">Lot No. {LotNumber}</Typography>
            <Typography
              dangerouslySetInnerHTML={{ __html: artist }}
            ></Typography>
            <Typography
              dangerouslySetInnerHTML={{ __html: title }}
            ></Typography>
            
          </div>
        </Grid>

        <Grid
          item
          md={6}
          style={{ margin: "auto", textAlign: "-webkit-center" }}
        >
          <Box style={{ textAlign: "center" }}>
            <div
              style={
                {
                  marginRight: 10,
                  marginTop:10
                  // height: 250,
                  //   width: 260,
                  // border: "1px solid #ccc",
                }
              }
            >
              <div
                className="centerImageOne"
                style={{
                  backgroundImage: `url(${image.length ? withdrawn === 1 ? WITHDRAWN_IMAGE:image[0].img_url  : NoImage})`, 
                  backgroundColor: "#ffffff",
                   width: phoneMatch === true ? 250:'100%',
                  height: 250,
                  display: "inline-block",
                  backgroundSize: "contain",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  padding: 10,
                }}
              ></div>

              
              {Datastatus === "" ? (
                sold
              ) : Datastatus === "SOLD" ? (
                <div
                  className="overlayDeclaratorCurrent"
                  style={{ color: "green" }}
                >
                  {" "}
                  SOLD{" "}
                </div>
              ) : Datastatus === "RESERVE_NOT_MET" ? (
                <div
                  className="overlayDeclaratorCurrent"
                  style={{ color: "#ff4949", paddingTop: "30%" }}
                >
                  RESERVE NOT MET
                </div>
              ) : Datastatus === "UNSOLD" ? (
                <div
                  className="overlayDeclaratorCurrent"
                  style={{ color: "#ff4949" }}
                >
                  UNSOLD
                </div>
              ) : (
                ""
              )}
            </div>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Current;
